import '../legacy/styles/spBootstrap.css';
import React from 'react';
import getCookies from 'next-cookies';
import '../polyfill';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import App from 'next/app';
import Head from 'next/head';
import withRedux from 'next-redux-wrapper';
import configureStore from '../legacy/shared/store';
import LegacyPage from '../legacy/root/LegacyPage';
import { Page as NewPage } from '../features/Layout';
import { isPreview } from '../features/utils';
import { QualarooSurvey } from '@mrkt/features/QualarooSurvey';
import { useCurrentUser } from '../@mrkt/useCurrentUser';
import { withHooks } from '@mrkt/features/withHooks';
import { compose } from 'redux';

// Customize NextJS app wrapper per page
// Here we dynamically import a different layout wrapper depending on
// if this is a "legacy" url, or a new "frodor" URL.

// Also uses withRedux() for legacy URLs to make sure the app store is
// passed to the client (see next-redux-wrapper library)

export class Site extends App {
  static async getInitialProps({ Component, ctx }) {
    const cookies = getCookies(ctx);
    const preview = isPreview(ctx);
    const activeSession = 'sp_dc' in cookies;
    const props =
      (await Component.getInitialProps?.({ ...ctx, preview, activeSession })) ||
      {};

    return {
      initialProps: { ...props, preview, activeSession },
    };
  }

  render() {
    const {
      Component,
      pageProps,
      store,
      initialProps,
      router,
      currentUser,
    } = this.props;
    const userId = currentUser?.partnerIds?.qualaroo;
    const additionalProperties = currentUser
      ? {
          name: currentUser.name,
          username: currentUser.username,
          loginEmail: currentUser.loginEmail,
          // qualaroo doesn't display boolean values on the ui, unsure if they are queryable
          hasAccess: `${currentUser.hasAccess}`,
        }
      : undefined;

    // display legacy page
    if (isLegacyPath(router.pathname)) {
      return (
        <>
          <Head>
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1"
            />
          </Head>

          <LegacyPage
            store={store}
            props={{ ...pageProps, ...initialProps }}
            Component={Component}
          />
          <QualarooSurvey
            identity={userId}
            additionalProperties={additionalProperties}
          />
        </>
      );
    }

    // display new page
    return (
      <>
        <Head>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Head>
        <NewPage
          props={{ ...pageProps, ...initialProps }}
          Component={Component}
          router={router}
        />
        <QualarooSurvey
          identity={userId}
          additionalProperties={additionalProperties}
        />
      </>
    );
  }

  componentDidMount() {
    if (process.browser && 'debug_assets' in this.props.router.query) {
      import(
        /* webpackChunkName: "axe" */ '@spotify-internal/axe-overlay'
      ).then(({ initializeAxeOverlay }) => {
        initializeAxeOverlay(undefined /* axe.RunOptions */);
      });
    }
  }
}

export function isLegacyPath(path) {
  const segments = path.split('/');
  const root = segments[1];
  const isBlogHub = root === 'blog' && segments.length === 2;

  return (
    ['facebook', 'faq', 'faq.plain', 'videos', 'contact', 'guide'].includes(
      root,
    ) || isBlogHub
  );
}

const withCurrentUser = withHooks(() => ({
  currentUser: useCurrentUser(),
}));

export default compose(withCurrentUser, withRedux(configureStore))(Site);
